import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

// Histórico de saques (ledger de auditoria). Consome o REST /withdrawals do backend: lista paginada
// das tentativas de saque (REAL/DRY-RUN/FALHA) + resumo (/summary) com série de lucro realizado.
const WITHDRAWALS_URL = getBaseUrl('/withdrawals/');

export async function getWithdrawals({ environment, status, page, limit } = {}) {
    const params = new URLSearchParams();
    if (environment) params.set('environment', environment);
    if (status) params.set('status', status);
    if (page) params.set('page', page);
    if (limit) params.set('limit', limit);
    const qs = params.toString();
    return await appRequest.doGetRequest(`${WITHDRAWALS_URL}${qs ? '?' + qs : ''}`);
}

export async function getWithdrawalsSummary(environment) {
    const params = new URLSearchParams();
    if (environment) params.set('environment', environment);
    const qs = params.toString();
    return await appRequest.doGetRequest(`${WITHDRAWALS_URL}summary${qs ? '?' + qs : ''}`);
}

// Wizard: provisiona a automação de realização de lucro pronta (template + automação + ação WITHDRAW).
// body: { addressId, profile?, startNow?, environment?, activate? }
export async function provisionSkimAutomation(body) {
    return await appRequest.doPostRequest(`${WITHDRAWALS_URL}provision-skim`, body);
}
